import { SignatureMethod } from '../types';

/**
 * Configuration for signature capture method.
 *
 * Options:
 * - UPLOAD_SIGNATURE: Only file upload (current behavior)
 * - CANVAS_SIGNATURE: Only canvas drawing (touch/mouse)
 * - UPLOAD_AND_CANVAS: Both methods available
 */
export const SIGNATURE_METHOD: SignatureMethod = SignatureMethod.UPLOAD_AND_CANVAS;
